export enum CONFIGURATION_PERMISSION {
  AIRCRAFTRATE = 'AIRCRAFTRATE',
  BROKERMGMT = 'BROKERMGMT',
}

export enum MENU_PERMISSIONS {
  DASHBOARD = 'DASHBOARD',
  CONTACTS = 'CONTACTS',
}

export enum SUBMENU_PERMISSIONS {
  DASHBOARD = 'DASHBOARD',
  REPORT = 'REPORT',
}

export enum GLOBAL_PERMISSIONS {
  VIEW_ROLE_MANAGEMENT = 'VIEWROLE',
  // Gates the System Settings → Team Management tab and route. VIEWTEAM used to; reading a team is
  // open to everyone now and that permission is retired.
  //
  // EDITTEAM is the nearest thing to "manages teams", not the only thing protecting the page —
  // ItemList already gates its edit icon on EDITTEAM and its Create New Team tile on CREATETEAM,
  // and a card click opens the team read-only with no permission at all. So this keeps Team
  // Management an admin entry point; it is not what stands between a user and team data.
  MANAGE_TEAM = 'EDITTEAM',
  VIEW_USER_MANAGEMENT = 'VIEWUSER',
  VIEW_CONTACT_PASSENGER = 'VIEWCONTACTPASSENGER',
  TRIP_CREATE = 'CREATETRIP',
  VIEWTRIP = 'VIEWTRIP',
  VIEW_TASKS = 'VIEW_TASKS',
  VIEW_JET_CARD_AGREEMENT = 'VIEWJCAGR',
  VIEW_SALES_DASHBOARD = 'SALESDASHBOARD',
  VIEW_FINANCE_DASHBOARD = 'FINANCEDASHBOARD',
  VIEW_LEADERSHIP_DASHBOARD = 'LEADERSHIPDASHBOARD',
  VIEW_LEADERBOARD_DASHBOARD = 'LEADERBOARDDASHBOARD',
  CREATECONTACT = 'CREATECONTACT',
  CREATEJCAGR = 'CREATEJCAGR',
  JCAGRAIRCRAFTRATE = 'JCAGRAIRCRAFTRATE',
  EDIT_OPERATOR_COST = 'EDITOPERATORCOST',
  EDITCONTACTNAMETYPE = 'EDITCONTACTNAMETYPE',
  UNMARKPURCHASEDLEAD = 'UNMARKPURCHASEDLEAD',
  EDITEMAILANDPHONE = 'EDITEMAILANDPHONE',
  EDITSIGNIFICANTOTHEREMAILPHONE = 'EDITSIGNIFICANTOTHEREMAILPHONE',
  REMOVECONTACTASSIGNMENT = 'REMOVECONTACTASSIGNMENT',
  EDITCONTACTIDENTITYDOCUMENT = 'EDITCONTACTIDENTITYDOCUMENT',
  EDITCONTACTSALESMATEID = 'EDITCONTACTSALESMATEID',
  MANAGE_COPILOT_INVITES = 'MANAGECOPILOTINVITES',
  MODIFY_COMMUNICATION_PREFERENCES = 'MODIFYCOMMUNICATIONPREFERENCES',
  VIEW_TRIP_REPORTS = 'VIEWTRIPREPORTS',
  MANAGE_TASK_TEMPLATES = 'MANAGE_TASK_TEMPLATES',
}

export enum PERMISSIONS {
  DELETE_CONTACT = 'DELETECONTACT',

  VIEW_CONTACT_IDENTITY = 'VIEWCONTACTIDENTITY',
  EDIT_CONTACT_PERSONALINFO = 'EDITCONTACTPERSONALINFO',
  EDIT_CONTACT_CONTACT_INFO = 'EDITCONTACTCONTACTINFO',
  EDIT_SIGNIFICANT_OTHER_INFO = 'EDITSIGNIFICANTOTHERINFO',
  EDIT_CONTACT_IDENTITY = 'EDITCONTACTIDENTITY',
  EDIT_CONTACT_ASSIGNMENT = 'EDITCONTACTASSIGNMENT',
  CREATE_EDIT_LEADERSHIP_CREDITS = 'CREATEEDITLEADERSHIPCREDITS',
  CREATE_EDIT_AD_HOC_CREDITS = 'CREATEEDITADHOCCREDITS',

  EDIT_JET_CARD_AGR = 'EDITJCAGR',
  CANCEL_JET_CARD_AGR = 'CANCELJCAGR',

  JC_MANUAL_CREDIT = 'JCMANUALCREDIT',
  JC_MANUAL_DEBIT = 'JCMANUALDEBIT',
  JC_MANUAL_DEBIT_WITHOUT_TRIP_ID = 'JCMANUALDEBITWITHOUTTRIPID',
  JC_STATEMENT = 'JCSTATEMENT',
  JC_DOWNLOAD_CONTRACT = 'JCDOWNLOADCONTRACT',
  JC_FIRST_PAYMENT = 'JCFIRSTPAYMENT',

  JC_AGR_MIN_FUND = 'JCAGRMINFUND',
  JC_AGR_AIRCRAFT_RATE = 'JCAGRAIRCRAFTRATE',
  JC_AGR_MIN_HOUR = 'JCAGRMINHOUR',
  JC_AGR_ESCROW = 'JCAGRESCROW',
  MODIFY_JC_AGR_ESCROW = 'MODIFYJCAGRESCROW',
  JC_DONT_SHOW_FUNDS_TO_CLIENT = 'DONTSHOWFUNDSTOCLIENT',
  JC_AGR_CATERING = 'JCAGRCATERING',
  MODIFY_JC_AGR_CATERING = 'MODIFYJCAGRCATERING',
  BYPASSJCPROMOTION = 'BYPASSJCPROMOTION',
  FINALIZEJC = 'FINALIZEJC',

  MODIFY_CONTACT_PASSENGER = 'MODIFYCONTACTPASSENGER',
  EDITPAYMINFO = 'EDITPAYMINFO',
  EDIT_TNC = 'EDITTNC',
  JC_EDIT_BROKER_COMMISSION = 'JCEDITBROKERCOMMISSION',
}

export enum TRIP_PERMISSIONS {
  EXPORT_TRIPS = 'EXPORTTRIPS',
  EDIT_TRIPS = 'EDITTRIPS',
  CREATE_DUPLTRIPS = 'CREATEDUPLTRIPS',
  CANCEL_TRIP = 'CANCELTRIP',
  DELETE_TRIPS = 'DELETETRIPS',
  CREATE_TRIP = 'CREATETRIP',
  EDIT_TRIP_LEGS = 'EDITTRIPLEGS',
  VIEWTRIPNOTES = 'VIEWTRIPNOTES',
  MODIIFYTRIPNOTES = 'MODIIFYTRIPNOTES',
  CLNTTRIPITINARY = 'CLNTTRIPITINARY',
  OPERTRIPITINARY = 'OPERTRIPITINARY',
  VIEWTRIPCONTRACT = 'VIEWTRIPCONTRACT',
  MANAGEOPCONTRACT = 'MANAGEOPCONTRACT',
  VIEWTRIPSCENARIOS = 'VIEWTRIPSCENARIOS',
  VIEWTRANSHISTORY = 'VIEWTRANSHISTORY',
  VIEWASSOCTRIPS = 'VIEWASSOCTRIPS',
  SKPCCAUTH = 'SKPCCAUTH',
  EDITCHTNC = 'EDITCHTNC',
  ACCJCTRIPPROP = 'ACCJCTRIPPROP',
  CANCELTRIP = 'CANCELTRIP',
  VIEWTRIPFEEDBACK = 'VIEWACTHISTTRIP',
  EDIT_SPECIAL_EVENTS_FEES = 'EDITSPECIALEVENTFEES',
  CREATE_EDIT_ETE_AND_HRS = 'CREATEEDITTRIPETEANDHRS',
  MANAGE_TRIP_REPORTS = 'MANAGETRIPREPORTS',
  FLAG_PAID_OPERATOR_DIFFERS = 'FLAGPAIDOPERATORDIFFERS',
}

export enum FINANCE_PERMISSION {
  VIEWTRIPFINANCEDETAIL = 'VIEWTRIPFINANCEDETAIL',
  EDITLEGTRIPREVIEW = 'EDITLEGTRIPREVIEW',
  EDITLEGFINANCEREVIEW = 'EDITLEGFINANCEREVIEW',
  EDITREVENUETRIPREVIEW = 'EDITREVENUETRIPREVIEW',
  EDITREVENUEFINANCEREVIEW = 'EDITREVENUEFINANCEREVIEW',
  EDITHANDLINGTRIPREVIEW = 'EDITHANDLINGTRIPREVIEW',
  EDITHANDLINGFINANCEREVIEW = 'EDITHANDLINGFINANCEREVIEW',
  EDITINTERNATIONALTRIPREVIEW = 'EDITINTERNATIONALTRIPREVIEW',
  EDITINTERNATIONALFINANCEREVIEW = 'EDITINTERNATIONALFINANCEREVIEW',
  EDITSPECIALTRIPREVIEW = 'EDITSPECIALTRIPREVIEW',
  EDITSPECIALFINANCEREVIEW = 'EDITSPECIALFINANCEREVIEW',
  RPTTRIPISSUE = 'RPTTRIPISSUE',
  CONFIRMSENDFIN = 'CONFIRMSENDFIN',
  SAVEFNLZTRIP = 'SAVEFNLZTRIP',
  UNFINALZ = 'UNFINALZ',
  PREVFININV = 'PREVFININV',
  PREVCLNTINV = 'PREVCLNTINV',
  VIEWTRIPFINANCELIST = 'VIEWTRIPFINANCELIST',
  VIEWOPERATORFINANCE = 'VIEWOPERATORFINANCE',
  EDITOPERATORFINANCE = 'EDITOPERATORFINANCE',
  BROKERTOREV = 'BROKERTOREV',
  EDITCOSTAFTERCANX = 'EDITCOSTAFTERCANX',
  EDITCANXSTATUS = 'EDITCANXSTATUS',
  VIEWREDUCEDPAYOUT = 'VIEWREDUCEDPAYOUT',
  EDITREDUCEDPAYOUT = 'EDITREDUCEDPAYOUT',
  EDITPAIDBEFORETRIPCOMP = 'EDITPAIDBEFORETRIPCOMP',
}
